<template>
  <div>
    <b-form-group
        label="Menü Ürün Kategorisi"
        label-for="itemidlow"
    >
      <v-select
          id="itemidlow"
          v-model="itemData.id_product_categories"
          :options="dataList"
          label="title"
          :reduce="item => item.id"
          placeholder="Seçiniz"
          @input="getDataList"
      >
        <template v-slot:option="option">
          <div>
            {{ option.title }}
          </div>
          <div>
            <small class="text-warning">{{ option.product_categories }}</small>
          </div>
        </template>
      </v-select>
    </b-form-group>
    <b-form-group
        label="Menü Ürün Alt Kategorisi"
        label-for="id_product_categories"
    >
      <v-select
          id="id_product_categories"
          v-model="itemData.id_low_product_categories"
          :options="dataListLow"
          label="title"
          :reduce="item => item.id"
          placeholder="Seçiniz"
          onselect="getDataList2(item.id)"
      >
        <template v-slot:option="option">
          <div>
            {{ option.title }}
          </div>
          <div>
            <small class="text-warning">{{ option.main_categories }}</small>
          </div>
        </template>
      </v-select>
    </b-form-group>
  </div>
</template>

<script>
import { BFormGroup } from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'ProductGroup',
  components: {
    BFormGroup,
    vSelect,
  },
  computed: {
    dataList() {
      return this.$store.getters['productGroups/dataList']
    },
    dataListLow() {
      return this.$store.getters['productGroups/dataListLow']
    },
    itemData() {
      return this.$store.getters['products/dataItem']
    },
  },
  created() {
    this.getDataList()
    this.getDataList2()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('productGroups/getDataList', {
        where: {
          'product_categories.id_product_categories ': null,
        },
      })
    },
    getDataList2(id) {
      this.$store.dispatch('productGroups/getDataList2', {
        where: { 'product_categories.id_product_categories ': id },
      })
    },
  },
}
</script>
